export default "__VITE_ASSET__BbwP4Wz7__"